import { render, staticRenderFns } from "./confirm-delete-dialog.vue?vue&type=template&id=81a19836"
import script from "./confirm-delete-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-delete-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports